var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyCircle = function SvgEmptyCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M12 2.05c-5.49 0-9.95 4.47-9.95 9.95s4.46 9.95 9.95 9.95 9.95-4.46 9.95-9.95S17.48 2.05 12 2.05m0 18.39c-4.66 0-8.45-3.79-8.45-8.45S7.34 3.55 12 3.55s8.45 3.79 8.45 8.45-3.79 8.45-8.45 8.45z"
  })));
};
export default SvgEmptyCircle;